import React, { createContext, useContext, ReactNode } from "react";

export type RawSellingPlanAllocation = {
    selling_plan_id: number | string;
    selling_plan_name?: string;
};

export type RawVariant = {
    id: number | string;
    title: string;
    grams?: number;
    price: string;
    selling_plan_allocations?: RawSellingPlanAllocation[];
};

export type RawProduct = {
    id: number | string;
    title: string;
    handle: string;
    description?: string;
    tags?: string[];
    image?: string[] | string;
    images?: string[];
    variants: RawVariant[];
     ingredients?: string[]; 
};

type ProductsContextValue = {
    planProducts: RawProduct[]; // bundles_collection
    mealProducts: RawProduct[]; // pouches_collection
    treatProducts: RawProduct[]; // treats_collection
    supplementProducts: RawProduct[]; // supplements_collection
    hiddenPriceProducts: RawProduct[]; // hidden_price_product_collection
    // ID mappings (days → productId)
    planProductMap: Record<string, string>;
    hiddenPriceMap: Record<string, string>;
};

const ProductsContext = createContext<ProductsContextValue | null>(null);

export function ProductsProvider({
    children,
    planProducts,
    mealProducts,
    treatProducts,
    supplementProducts,
    hiddenPriceProducts,
    planProductMap,
    hiddenPriceMap,
    
}: {
    children: ReactNode;
    planProducts: RawProduct[];
    mealProducts: RawProduct[];
    treatProducts: RawProduct[];
    supplementProducts: RawProduct[];
    hiddenPriceProducts?: RawProduct[];
    planProductMap?: Record<string, string>;
    hiddenPriceMap?: Record<string, string>;
}) {
    return (
        <ProductsContext.Provider
            value={{
                planProducts: planProducts || [],
                mealProducts: mealProducts || [],
                treatProducts: treatProducts || [],
                supplementProducts: supplementProducts || [],
                hiddenPriceProducts: hiddenPriceProducts || [],
                planProductMap: planProductMap || {},
                hiddenPriceMap: hiddenPriceMap || {},
                
            }}
        >
            {children}
        </ProductsContext.Provider>
    );
}

export function useProducts() {
    const ctx = useContext(ProductsContext);
    if (!ctx) {
        throw new Error("ProductsProvider missing in React tree");
    }
    return ctx;
}